import { useState } from 'react'
import type { PromptDraftDto } from '@lunary/api-client'
import { usePromptContent, useUpdatePromptDraft } from './queries'
import { PromptDiff } from './prompt-diff'

type Props = { readonly draft: PromptDraftDto }

export function PromptDraftEditor({ draft }: Props) {
  const update = useUpdatePromptDraft()
  const base = usePromptContent(draft.scope, draft.name, draft.base_version)
  const [title, setTitle] = useState(draft.title)
  const [content, setContent] = useState(draft.content)
  const [showDiff, setShowDiff] = useState(false)
  const dirty = title !== draft.title || content !== draft.content

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      <input value={title} maxLength={200} placeholder="Название черновика" aria-label="Название черновика" onChange={(e) => setTitle(e.target.value)} />
      <textarea rows={18} value={content} maxLength={20000} aria-label="Текст промпта" onChange={(e) => setContent(e.target.value)} />
      <div className="row">
        <button
          disabled={!dirty || update.isPending || content.trim().length === 0}
          onClick={() => update.mutate({ id: draft.id, body: { title, content } })}
        >
          {update.isPending ? 'Сохраняю…' : 'Сохранить черновик'}
        </button>
        <button className="secondary" onClick={() => setShowDiff((v) => !v)}>
          {showDiff ? 'Скрыть отличия' : `Отличия от v${draft.base_version}`}
        </button>
        {update.isSuccess && !dirty && <span className="muted">Сохранено</span>}
      </div>
      {update.error && <p className="error-box">{update.error instanceof Error ? update.error.message : 'Ошибка'}</p>}
      {showDiff && base.data && <PromptDiff before={base.data.content} after={content} labels={[`v${draft.base_version}`, 'черновик']} />}
    </div>
  )
}
